import { render, staticRenderFns } from "./WeekReview.vue?vue&type=template&id=d0c7ebfc&"
import script from "./WeekReview.vue?vue&type=script&lang=js&"
export * from "./WeekReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports